<template>
    <v-main>
        <v-container fluid>
            <v-row cols="12">
                <v-col cols="12">
                    <tableFaqGeneral ref="tableFaqGeneral" />
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import tableFaqGeneral from '@/components/syst/openai/tableFaqGeneral.vue';

    export default {        
        components: {
            navbar,
            tableFaqGeneral,
        },
        data() {
            return {
            }
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {
            },           
        },
    }
</script>

<style scoped>
</style>
